require('./openYoungDashboardChoresContent.scss');

// @vendors
const { isEmpty } = require('lodash');
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @commons
const { EmptyState } = require('commonsComponents/emptyState');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');

// @components
const { ChoreListTableInfoRow } = require('routes/openYoungCardsView/openYoungCardChoresView/components/choreListTableInfoRow/choreListTableInfoRow');
const { ChoreListTableRow } = require('routes/openYoungCardsView/openYoungCardChoresView/components/choreListTableRow/choreListTableRow');

// @constants
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const MAX_ROWS_LIMIT = 5;

const language = getLanguage();
class OpenYoungDashboardChoresContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedRowId: '',
        }

        this.getAddTaskButton = this.getAddTaskButton.bind(this);
        this.handleCreateChore = this.handleCreateChore.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);
        this.loadChoreList = this.loadChoreList.bind(this);
        this.viewMoreChores = this.viewMoreChores.bind(this);
    }

    handleCreateChore() {
        const { cardId, history } = this.props;
        history.push(`/myprofile/cards/${cardId}/chores/create-chore`);
    }

    viewMoreChores() {
        const { cardId, history } = this.props;
        history.push(`/myprofile/cards/${cardId}/chores`);
    }

    handleRowClick(rowId) {
        this.setState(prevState => ({expandedRowId: rowId === prevState.expandedRowId ? '' : rowId}));
    }

    handleRetry() {
        const { cardInfo, getChildDetails } = this.props;
        getChildDetails(cardInfo);
    }

    getAddTaskButton() {
        return (
            <OKButton
                modifier="ghost"
                onClick={this.handleCreateChore}
                leftIcon="icon-agregar"
            >
                <FormattedText value={'openYoungDashboardView-openYoungDashboardView_createTask'} />
            </OKButton>
        );
    }

    getMoreChoresLink() {
        const { cardId } = this.props;
        return (
            <div className="open-young-dashboard-chore-content__view-more-items">
                <OKLink
                    modifier="widget"
                    inverse={true}
                    to={`/myprofile/cards/${cardId}/chores`}
                >
                    <FormattedText value={'openYoungDashboardView-openYoungDashboardView_viewMoreChores'} />
                </OKLink>
            </div>
        );
    }

    loadChoreList(openYoungDashboardChildDetails) {

        const { expandedRowId } = this.state;
        const tableHeaders = ['date', 'status', 'task', 'amount'];
        const tableHeaderElements = tableHeaders.map((header, index) => (
            <OKTableCell className={`open-young-chores__header-cell--${header}`} asHeader={true} key={index}>
                <FormattedText format="uppercase" value={`openYoungChoresList-${header}`} />
            </OKTableCell>
        ));
        let choreList;

        if (openYoungDashboardChildDetails.get('getChildDetailsFetch')) {
            choreList = (
                <LoadingSection />
            );
        } else if (openYoungDashboardChildDetails.get('getChildDetailsChoresError')) {
            const retryButton = (
                <OKButton onClick={this.handleRetry}>
                    <FormattedText value="openYoungChores-retry" />
                </OKButton>
            );

            choreList = (
                <EmptyState
                    primaryText={formatText('openYoungChores-apiFailure')}
                    button={retryButton}
                    iconType="nointernet-banking"
                />
            );
        } else if (openYoungDashboardChildDetails.get('byOrder').size === 0) {
            choreList = (
                <EmptyState
                    primaryText={formatText('openYoungDashboardView-openYoungDashboardView_choreEmptyList')}
                    iconType="search-banking"
                    button={this.getAddTaskButton()}
                />
            );
        } else if (openYoungDashboardChildDetails.get('byOrder').size > 0 && !isEmpty(openYoungDashboardChildDetails.get('byId'))) {
            let byOrder = openYoungDashboardChildDetails.get('byOrder');
            let byId = openYoungDashboardChildDetails.get('byId');
            if (byOrder.size > MAX_ROWS_LIMIT) {
                byOrder = byOrder.slice(0, MAX_ROWS_LIMIT);
                byOrder = byOrder.slice(0, MAX_ROWS_LIMIT);
            }

            choreList = (
                <React.Fragment>
                    <LastMovementsTable
                        groupByDate={true}
                        columnsCount={7}
                        id="chore-list-table"
                        rowComponent={ChoreListTableRow}
                        immTransactionsByOrder={byOrder}
                        immTransactionsById={byId}
                        expandedRowId={expandedRowId}
                        expandedRowComponent={ChoreListTableInfoRow}
                        onRowClick={this.handleRowClick}
                        currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                        language={language}
                    >
                        <thead>
                            <OKTableRow asHeader={true}>
                                <OKTableCell
                                    asHeader={true}
                                    className="open-young-chores__header-cell open-young-chores__header-cell--toggler"
                                />
                                {tableHeaderElements}
                                <OKTableCell
                                    className="open-young-chores__header-cell--buttons"
                                    asHeader={true}
                                />
                            </OKTableRow>
                        </thead>
                    </LastMovementsTable>
                </React.Fragment>
            );
        }
        return (choreList);
    }

    render() {
        const { immOpenYoungDashboardChildDetails } = this.props;
        const tareasTitle = formatText('openYoungDashboardView-openYoungDashboardView_tareasTitle');
        const showAddButton = (
            immOpenYoungDashboardChildDetails.get('byOrder').size > 0 && this.getAddTaskButton()
        );

        const nextPageButtonContainer = (
            immOpenYoungDashboardChildDetails.get('byOrder').size > MAX_ROWS_LIMIT && this.getMoreChoresLink()
        );
        return (
            <div className="open-young-dashboard-chore-content">
                <div className="open-young-dashboard-chore-content__header row">
                    <div className="open-young-dashboard-chore-content__title col-xs-9">
                        <OKBoxTitle
                            value={tareasTitle}
                            isNotSeparator={true}
                        />
                    </div>
                    <div className="open-young-dashboard-chore-content__add col-xs-3">
                        {showAddButton}
                    </div>
                </div>
                <div className="open-young-dashboard-chore-content__table">
                    {this.loadChoreList(immOpenYoungDashboardChildDetails)}
                </div>
                {nextPageButtonContainer}
            </div>
        );
    }
}

OpenYoungDashboardChoresContent.propTypes = {
    cardId: PropTypes.object,
    cardInfo: PropTypes.object.isRequired,
    getChildDetails: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immOpenYoungDashboardChildDetails: PropTypes.object.isRequired,
};
module.exports = withRouter(OpenYoungDashboardChoresContent);

